/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * 0 = Unknown
 * 1 = Administrator
 * 2 = UserViaRegistration
 * 3 = UserViaRegistrationKey
 * 5 = Seed
 */
export enum PlatformAccountCreatedByMethod {
  Unknown = 0,
  Administrator = 1,
  UserViaRegistration = 2,
  UserViaRegistrationKey = 3,
  Seed = 5
}
